import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'save-card',
  templateUrl: './save-card.component.html',
  styleUrls: ['./save-card.component.sass']
})
export class SaveCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/demo/save-card/save-card.component.ts